/**
 * TODO TJS: Remove once Product Embeds are migrated
 *
 * Describes elements in a product set.
 *
 */

var sw            = require('js/lib/sw');
var _             = require('underscore');
var ShapewaysView = require('./ShapewaysView');
var template      = require('rrTags/product_sets/templates/tpl.product-box-item-row.mustache');

var ProductDescriptionBox = ShapewaysView.extend({

  events: {
    'click [data-sw-product-description-in-button]': 'showIn',
    'click [data-sw-product-description-cm-button]': 'showCm'
  },

  initialize: function() {
    this.listenTo(this.model, 'change:currentConfigurationId', this.repaint, this);
    this.$itemList = this.$('[data-sw-product-description-box-item-list]');

    // Starts out cm by default.
    this.currentUnit = 'cm';

    // Selector strings used for toggling.
    this.inBtn = '[data-sw-product-description-in-button]';
    this.cmBtn = '[data-sw-product-description-cm-button]';
    this.inGroup = '[data-sw-product-description-witb-in-group]';
    this.cmGroup = '[data-sw-product-description-witb-cm-group]';
  },

  showCm: function() {
    this.currentUnit = 'cm';
    this.$(this.cmGroup).swShow();
    this.$(this.inGroup).swHide();

    this.updateSelectorBtn();
  },

  showIn: function() {
    this.currentUnit = 'in';
    this.$(this.inGroup).swShow();
    this.$(this.cmGroup).swHide();

    this.updateSelectorBtn();
  },

  updateSelectorBtn: function() {
    var isCm = this.currentUnit === 'cm';
    var btnPrimary = isCm ? this.cmBtn : this.inBtn;
    var btnUnselected = isCm ? this.inBtn : this.cmBtn;

    this.$(btnPrimary).addClass('btn-primary');
    this.$(btnUnselected).removeClass('btn-primary');
  },

  /**
   * Makes sure units are linked to their selector on a render.
   */
  assignUnits: function() {
    if (this.currentUnit === 'cm') {
      this.showCm();
    } else {
      this.showIn();
    }
  },

  render: function() {
    var productItems = this.model.getCurrentConfiguredProductItems();

    if (_.isEmpty(productItems)) {
      this.$el.swHide();
      return;
    }

    var html = '';

    // this is how we'll get by for now
    _.each(productItems, function(item) {

      var rowParams = sw.utils.cloneDataObject(item);
      var currentConfigurationId = this.model.get('currentConfigurationId');

      if (!currentConfigurationId) {
        return;
      }

      var indexCell = this.model.attributes.productItemConfigurationPictureIndex[currentConfigurationId];

      if (!indexCell) {
        return;
      }

      var pictureId = indexCell.pictureId;
      var picture = this.model.attributes.pictures[pictureId];

      if (!picture) {
        picture = {};
      }

      // Empty entries on the picture will be handled silently by the mustache
      // template
      rowParams.thumbImage = {
        pictureUrl: picture.pictureUrl,
        pictureDescription: picture.pictureDescription
      };

      html += template.render(rowParams);
    }, this);

    if (html) {
      this.$itemList.html(html);
      this.$el.swShow();
      this.assignUnits();
    }
  }

});

module.exports = ProductDescriptionBox;
